const DEFAULT_SUPPORT_LINKS = {
  createTicketUrl: 'https://managedservices.ctl.io/msp/oauth/login?state=request',
  supportCenterUrl: 'https://managedservices.ctl.io/msp/oauth/login',
  knowledgeBaseUrl: 'https://www.ctl.io/knowledge-base/',
  feedbackUrl: 'http://centurylinkcloud.uservoice.com',
  statusUrl: 'https://status.ctl.io'
};

export { DEFAULT_SUPPORT_LINKS };



// WEBPACK FOOTER //
// ./src/scripts/defaults.js